import { type ConfigResult } from '../types/configTypes';

export function parseConfigResult(data?: Partial<ConfigResult>): ConfigResult {
  if (!isConfigResult(data)) {
    console.error('[parseConfigResult] data is missing required properties', { data });

    throw new Error(`[parseConfigResult] data is missing required properties ${JSON.stringify(data)}`);
  }

  return data;
}

function isConfigResult(data?: Partial<ConfigResult>): data is ConfigResult {
  return Boolean(
    data?.template_uris?.category_detail_page_uri &&
      data.template_uris.clip_watch_page_uri &&
      data.template_uris.entity_mapper_mget_uri &&
      data.template_uris.entity_mapper_uri &&
      data.template_uris.epg_by_callsign_uri &&
      data.template_uris.epg_watch_page_uri &&
      data.template_uris.episode_watch_page_uri &&
      data.template_uris.event_detail_page_uri &&
      data.template_uris.experimentation_uri &&
      data.template_uris.keygen_uri &&
      data.template_uris.league_detail_page_uri &&
      data.template_uris.movie_detail_page_uri &&
      data.template_uris.movie_watch_page_uri &&
      data.template_uris.network_detail_page_uri &&
      data.template_uris.playlist_watch_page_uri &&
      data.template_uris.series_detail_page_uri &&
      data.template_uris.shorts_explore_feed_uri &&
      data.template_uris.shorts_similar_feed_uri &&
      data.template_uris.special_detail_page_uri &&
      data.template_uris.special_watch_page_uri &&
      data.template_uris.sporting_event_watch_page_uri &&
      data.template_uris.sports_detail_page_uri &&
      data.template_uris.talent_detail_page_uri &&
      data.template_uris.team_detail_page_uri &&
      data.dynamic_uris?.navigation_uri &&
      data.dynamic_uris.live_schedule_page_uri &&
      data.search_uris?.autosuggest_uri &&
      data.search_uris.discover_uri &&
      data.search_uris.trending_uri,
  );
}
